import { render } from "./ReportSettings.vue?vue&type=template&id=6d8fb7bc&scoped=true"
import script from "./ReportSettings.vue?vue&type=script&lang=js"
export * from "./ReportSettings.vue?vue&type=script&lang=js"

import "./ReportSettings.vue?vue&type=style&index=0&id=6d8fb7bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8fb7bc"]])

export default __exports__